"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const leaflet_1 = __importDefault(require("leaflet"));
const EARTH_CIRCUMFERENCE = 40030000;
exports.toRadians = (angle) => {
    return angle * (Math.PI / 180);
};
exports.toDegrees = (angle) => {
    return angle * (180 / Math.PI);
};
exports.setPrecision = (value, precision) => {
    return +Number(value).toPrecision(precision);
};
exports.calculateRadius = (point1, point2) => {
    const leafletPoint = new leaflet_1.default.LatLng(point1[0], point1[1]);
    return leafletPoint.distanceTo(point2);
};
exports.calculateCircleBox = (circle) => {
    const { center, radius } = circle;
    const degreeSep = (radius * 360) / EARTH_CIRCUMFERENCE;
    return [
        [center[0] + degreeSep, center[1] - degreeSep],
        [center[0] - degreeSep, center[1] + degreeSep]
    ];
};
exports.stringifyPoint = (point) => {
    return `(${point[0]},${point[1]})`;
};
exports.stringifyCircle = (circle) => {
    const point = exports.stringifyPoint(circle.center);
    return `(${point} - ${Math.round(circle.radius)})`;
};
exports.stringifyRectangle = (rectangle) => {
    return `[${exports.stringifyPoint(rectangle[0])},${exports.stringifyPoint(rectangle[1])}]`;
};
exports.stringifyPointSeries = (pointSeries) => {
    let stringPointSeries = "[";
    pointSeries.forEach(point => (stringPointSeries += exports.stringifyPoint(point)));
    stringPointSeries += "]";
    return stringPointSeries;
};
exports.indexOfObject = (arr, value) => {
    const stringVal = JSON.stringify(value);
    let i = 0;
    for (const obj of arr) {
        if (stringVal === JSON.stringify(obj)) {
            return i;
        }
        i += 1;
    }
    return -1;
};
